/* Co-ordinate existing drawers, sticky purchase controls and third-party launchers. */
(() => {
  let frame;
  const chatFrames = new WeakMap();
  const chatRoots = new WeakSet();
  function syncOverlays() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const open = !!document.querySelector(
        "cart-drawer.active, menu-drawer details[open], header-drawer details[open], .mobile-facets__disclosure[open], quick-add-modal[open], modal-dialog[open]",
      );
      document.body.classList.toggle("pn-overlay-open", open);
      // These existing Selleasy campaigns advertise drink accessories. Preserve
      // the integration while avoiding them for cakes, Home Spa and digital gifts.
      document
        .querySelectorAll(".lb-addon-cont, .lb-bundle-cont")
        .forEach((offer) => {
          const heading = offer
            .querySelector(".lb-addon-title, .lb-bundle-title")
            ?.textContent.trim();
          const drinkCampaign =
            heading === "Dit maakt je drankje compleet" ||
            heading === "Perfect voor jouw Pineut drankje";
          const context =
            offer.closest("cart-drawer")?.querySelector(".drawer__inner") ||
            document.querySelector("product-info[data-pineut-drinks]");
          offer.classList.toggle(
            "pn-irrelevant-offer",
            drinkCampaign && context?.dataset.pineutDrinks === "false",
          );
        });
      const sticky = document.querySelector(
        ".section-product-page .sticky-cta",
      );
      const primaryButton = document.querySelector(
        '.section-product-page .main-atc-form [type="submit"]',
      );
      const footer = document.querySelector("footer.footer");
      const visible =
        !!sticky &&
        !!primaryButton &&
        primaryButton.getBoundingClientRect().bottom < 0 &&
        (!footer || footer.getBoundingClientRect().top > innerHeight) &&
        !open;
      sticky?.classList.toggle("pn-is-visible", visible);
      document.body.classList.toggle("pn-sticky-visible", visible && !open);
      const stickyHeight = visible
        ? Math.ceil(sticky.getBoundingClientRect().height)
        : 0;
      document.documentElement.style.setProperty(
        "--pn-sticky-space",
        `${stickyHeight}px`,
      );
      // Zapier positions its iframe inside an open shadow root. Moving the host
      // alone does not move that fixed iframe. Restore the app's own offset when idle.
      const chatRoot = document.querySelector(
        "zapier-interfaces-chatbot-embed",
      )?.shadowRoot;
      if (chatRoot && !chatRoots.has(chatRoot)) {
        chatRoots.add(chatRoot);
        observer.observe(chatRoot, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ["class"],
        });
      }
      const chatFrame = chatRoot?.querySelector("iframe.is-zpopup");
      if (chatFrame) {
        if (!chatFrames.has(chatFrame))
          chatFrames.set(chatFrame, {
            bottom: chatFrame.style.bottom,
            visibility: chatFrame.style.visibility,
            pointerEvents: chatFrame.style.pointerEvents,
          });
        const original = chatFrames.get(chatFrame);
        chatFrame.style.bottom = visible
          ? `${stickyHeight + 12}px`
          : original.bottom;
        chatFrame.style.visibility = open ? "hidden" : original.visibility;
        chatFrame.style.pointerEvents = open ? "none" : original.pointerEvents;
      }
    });
  }
  const observer = new MutationObserver((records) => {
    if (
      records.some(
        (r) =>
          r.target !== document.body && r.target !== document.documentElement,
      )
    )
      syncOverlays();
  });
  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["open", "class"],
  });
  addEventListener("scroll", syncOverlays, { passive: true });
  addEventListener("resize", syncOverlays, { passive: true });
  document.addEventListener("shopify:section:load", syncOverlays);
  // Delegate to the stable section: variant rendering replaces the sticky button.
  document.addEventListener("click", (event) => {
    const button = event.target.closest(
      ".section-product-page .sticky-cta button",
    );
    if (!button) return;
    event.preventDefault();
    const form = button
      .closest(".section-product-page")
      ?.querySelector("product-form .main-atc-form");
    if (
      !form ||
      button.disabled ||
      button.getAttribute("aria-disabled") === "true"
    )
      return;
    if (!form.reportValidity()) {
      form.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    form.querySelector('[type="submit"]')?.click();
  });
  customElements
    .whenDefined("zapier-interfaces-chatbot-embed")
    .then(syncOverlays);
  syncOverlays();
})();
